import type { FormEvent } from 'react';
import { useState } from 'react';
import { Card, Form, Button, InputGroup } from 'react-bootstrap';
import { Search } from 'lucide-react';

interface CustomerSearchProps {
  onSearch: (customerId: string) => void;
}

export const CustomerSearch = ({ onSearch }: CustomerSearchProps) => {
  const [customerId, setCustomerId] = useState('');

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();
    if (customerId.trim()) {
      onSearch(customerId.trim());
    }
  };

  return (
    <Card className="mb-4">
      <Card.Body>
        <Card.Title>Search Customer</Card.Title>
        <Form onSubmit={handleSubmit}>
          <InputGroup>
            <Form.Control
              type="text"
              placeholder="Enter Customer ID"
              value={customerId}
              onChange={(e) => setCustomerId(e.target.value)}
            />
            <Button type="submit" variant="primary">
              <Search size={16} className="me-2" />
              Search
            </Button>
          </InputGroup>
        </Form>
      </Card.Body>
    </Card>
  );
};
